import { createStore } from "vuex";

export default createStore({
  state: {
    infoStep: 0,
    unityInstance: {} as any,
    isCampaign: false,
    campaign: [],
    isLoginCampaignWindow: true,
    selectCampaign: undefined,
    selectPostCampaign: undefined,
    postedCampaign: false,
    showPostedCampaign: false,
    ready: false,
    readyNotice: false,
  },
  getters: {
    getNewMemberCampaign(state) {
      return state.campaign.find(
        (v: any) => v.id === "new_register_2023" && v.canApply && !v.isApply
      );
    },

    getLoginCampaign(state) {
      return state.campaign.find(
        (v: any) =>
          v.id !== "new_register_2023" &&
          v.type === "LoginCampaign" &&
          v.canApply &&
          !v.isApply
      );
    },
  },
  mutations: {
    setInfoStep(state, value) {
      state.infoStep = value;
    },

    setUnityInstance(state, value) {
      state.unityInstance = value;
    },

    setCampaign(state, value) {
      state.campaign = value;
    },

    setIsLoginCampaignWindow(state, value) {
      state.isLoginCampaignWindow = value;
    },

    setSelectCampaign(state, value) {
      state.selectCampaign = value;
    },

    setSelectPostCampaign(state, value) {
      state.selectPostCampaign = value;
    },

    setPostedCampaign(state, value) {
      state.postedCampaign = value;
    },

    setShowPostedCampaign(state, value) {
      state.showPostedCampaign = value;
    },

    setReady(state, value) {
      state.ready = value;
    },

    setReadyNotice(state, value) {
      state.readyNotice = value;
    },
  },
  actions: {},
  modules: {},
});
